import React from "react";
import { Home as HomeIcon } from "lucide-react";
import { useAuth } from "../hooks/AuthenticationProvider";

const HouseIcon = ({ resident }) => {
  const { organizationData } = useAuth(); // Fetch the organization data dynamically
  const housesData = organizationData?.housesData || {}; // Ensure housesData is defined

  // Dynamically get the color based on the resident's house
  const houseColor = housesData[resident.house]?.color || "#c713d4"; // Fallback to purple if house is not found

  return (
    <div className="flex flex-row justify-center items-center gap-1 rounded-md">
      <HomeIcon className="w-6 h-6" style={{ fill: houseColor }} />
      <span style={{ color: houseColor }}>{resident.house}</span>
    </div>
  );
};

export default HouseIcon;
